import axios from '../helpers/axios';
import * as errors from '../errors';
import type { AppThunk, Notify } from '../typings/redux';
import { getTranslationKey } from '../modules/utils';

export const getPayments = (): AppThunk<Promise<void>> => async (dispatch) => {
  try {
    const res = await axios.get('/api/bookingPaymentTransactions');
    dispatch({ type: 'SET_ALL_PAYMENTS', payload: res.data });
  } catch (e) {
    errors.handleErrorWithRedirectIfNotAuth(e);
  }
};

export const createPaymentGateway =
  (data: any, notify: Notify): AppThunk<Promise<void>> =>
  async () => {
    try {
      await axios.post('/api/me/paymentgateway', data);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('refreshedData'),
        status: 'success',
        position: 'bottom-left',
        dismissible: true,
        dismissAfter: 3000
      });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const updatePaymentGateway =
  (data: any, notify: Notify): AppThunk<Promise<void>> =>
  async () => {
    try {
      await axios.put('/api/me/paymentgateway', data);
      notify({
        title: getTranslationKey('success'),
        message: getTranslationKey('refreshedData'),
        status: 'success',
        position: 'bottom-left',
        dismissible: true,
        dismissAfter: 3000
      });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e, notify);
    }
  };

export const getPaymentGateway =
  (type: string): AppThunk<Promise<void>> =>
  async (dispatch) => {
    try {
      const res = await axios.get<Record<string, any>>(`/api/me/paymentgateway?type=${type}`);
      dispatch({ type: 'SET_PAYMENT_GATEWAY', payload: { data: res.data[type], type } });
    } catch (e) {
      errors.handleErrorWithRedirectIfNotAuth(e);
    }
  };

export const buyOrUpgradeSubscription =
  (
    type: string,
    product: string,
    plan: string,
    intervall: string,
    notify?: Notify
  ): AppThunk<Promise<void>> =>
  async () => {
    try {
      if (
        product === 'scrappbook' ||
        type !== 'downgrade' ||
        (type === 'downgrade' && window.confirm(getTranslationKey('pricingTables.downgradeHint')))
      ) {
        const res = await axios.get(`/api/subscription/${type}/${product}/${plan}/${intervall}`);

        if (res.data.result === 'success') {
          window.location.href = res.data.url;
        } else {
          notify &&
            notify({
              title: getTranslationKey('error'),
              message: getTranslationKey('pricingTables.error'),
              status: 'error',
              position: 'top-center',
              dismissible: true,
              dismissAfter: 7500
            });
        }
      }
    } catch (e) {
      notify &&
        notify({
          title: getTranslationKey('error'),
          message: getTranslationKey('pricingTables.error'),
          status: 'error',
          position: 'top-center',
          dismissible: true,
          dismissAfter: 7500
        });
      errors.handleErrorWithRedirectIfNotAuth(e);
    }
  };
